import { useEffect, useState } from 'react';

const CoinProgressBar = ({ loaded }: { loaded: boolean }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (loaded) {
      setProgress(100);
      setTimeout(() => setProgress(-1), 1000);
    } else {
      setProgress(10);
    }
  }, [loaded]);

  if (progress < 0) {
    return <></>;
  }

  return (
    <div className="absolute left-0 right-0 h-[2px] bg-[#ccc]" style={{ top: '56px' }}>
      <div className="h-full transition-all duration-500" style={{ width: `${progress}%`, background: 'var(--bcs-semantic-base-bg-purple)' }} />
    </div>
  );
};

export default CoinProgressBar;
